import { generateTranslationKey, toProperCase } from '../../utils/convert.util';
import Translations from '../Translations';
import _ from 'lodash';
import React, {} from 'react';
import {
    Grid,
    Card,
    Header,
    // Message,
    Icon,
} from 'semantic-ui-react';

import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import DATETIME_UTILITY from '../../utils/datetime';
import ModalViewDocument from '../modal/viewdocument';
import {formatAmountWithCurrency} from '../../utils/currency';

const HistoryPageProduct = (props) => {

    const {
        productKey,
        product,
        coverages,
        family,
        currencyMinorUnit,
        currency,
    } = props;

    // console.log('coverages->', coverages);

    const renderCoverages = () => {
        return _.map(
            _.keysIn(coverages), 
            (member) => {
                const m_c_list = coverages[member];
                // get member data
                const m = HELPER_FUNCTION_UTILITY.getMemberFromFamily(
                    family,
                    member,
                );

                let output = [];
                for (let i = 0; i < m_c_list.length; i++) {
                    const _c = m_c_list[i];

                    const option = _c.selectOption;
                    const effectiveStartDate = DATETIME_UTILITY.parseDateTimeFromUTC(_c.effectiveStartDate).format("DD MMM");
                    const effectiveEndDate = DATETIME_UTILITY.parseDateTimeFromUTC(_c.effectiveEndDate).format("DD MMM");
                    const status = _c.status;
                    const priceSign = (option.price > 0) ? '-' : (option.price < 0) ? '+' : '';

                    output.push(
                        <div key={`${productKey}-${member}-${i}`}>
                            <div style={{fontSize: 12}}>
                                {`${effectiveStartDate} - ${effectiveEndDate}`}
                            </div>
                            <div className="history-option-row">
                                <b className="history-option-name">{option.name}</b>
                                <b className="history-option-price">{formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas((option.price >= 0) ? option.price : option.price * -1, currencyMinorUnit), currency, priceSign)}</b>
                            </div>
                        </div>
                    );
                }

                return (
                    <Card.Content key={member}>
                        <div style={{float: "right"}}>
                            <Icon name="sort down" color="grey" />
                        </div>
                        <p className="history-member-name">
                            {toProperCase(m.name)}
                        </p>
                        {output}
                    </Card.Content>
                );
            }
        );
    };

    return (
        <Grid.Column>
            <Header as="h4" className="history-product-header">
                <div style={{float: "right"}}>
                    <ModalViewDocument document={product.summaryUrl} />
                </div>
                <Translations text={`insurance_product.${generateTranslationKey(product.name)}`} backup={product.name} />
            </Header>
            <Card fluid>
                {/* <Card.Content>
                    <Card.Header><Translations text={`insurance_product.${generateTranslationKey(product.name)}`} backup={product.name} /></Card.Header>
                </Card.Content> */}
                {renderCoverages()}
            </Card>
        </Grid.Column>
    );
};

export default HistoryPageProduct;
